import React from 'react';
import BookingAgent from './BookingAgent';
import { FlightBookingProvider } from '../../../components/BookingAgent/context/FlightBookingContext';
import { HotelBookingProvider } from '../../../components/BookingAgent/context/HotelBookingContext';

function BookingAgentWrapper() {
  return (
    <FlightBookingProvider>
      <HotelBookingProvider>
        <BookingAgent />
      </HotelBookingProvider>
    </FlightBookingProvider>
  );
}

export default BookingAgentWrapper;
